import { Sphere } from '@/components/Sphere';
import { Logo } from '@/components/Logo';
import { LangToggle } from '@/components/LangToggle';
import { useLang } from '@/i18n';
import styles from './PublicEvent.module.css';

export function NotFound() {
  const { t } = useLang();
  return (
    <div className={`brand-scale ${styles.shell}`}>
      <Sphere />
      <header className={styles.brand}>
        <Logo height={36} />
        <LangToggle />
      </header>
      <main className={styles.main}>
        <section className={styles.message}>
          <p className={styles.eyebrow}>404</p>
          <h1 className={styles.h1}>{t('page_404_title')}</h1>
          <p className={styles.lead}>{t('page_404_body')}</p>
        </section>
      </main>
    </div>
  );
}
